const RulerToolEnum = {
  RULER_IS_ACTIVE: 'RULER_IS_ACTIVE',
  SET_RULER_COLOR: 'SET_RULER_COLOR',
  TOGGLE_RULER_TOOL: 'TOGGLE_RULER_TOOL',
};

export default RulerToolEnum;



// WEBPACK FOOTER //
// ./src-react/RulerTool/RulerToolConstants.jsx